/**
 * Enum defining the different types of enemies in the game
 */
export enum EnemyType {
  GRUNT = 'GRUNT',     // Basic melee enemy
  ARCHER = 'ARCHER',   // Ranged enemy that shoots arrows
  BRUTE = 'BRUTE',     // Stronger melee enemy with more health
  BOSS = 'BOSS'        // End-of-wave boss enemy
} 